import React from 'react'

import { OrderItemV3 } from '~/components/order-item'
import { getPricingDetails, getTotalPrice } from '~/utils/cart'
import fullName from '~/utils/full-name'

import { PassList } from './order-content.styles'

import type { ReactNode } from 'react'
import type { ComputedCartParticipant, CartItem, Product } from '~/types'

type Props = {
  forceShowTotalLineItem?: boolean
  onAddonToggle?: (
    insurance: boolean,
    internalId: string,
    addonType: string,
  ) => void
  onRemove?: (item: CartItem) => void
  profiles: ComputedCartParticipant[]
  products?: Product[]
}

const OrderContentV3 = (props: Props) => {
  const isUpgrade = (item: CartItem): boolean => {
    const { products } = props

    const itemProduct = products
      ? products.find(({ id }) => id === item.type)
      : undefined

    return !!itemProduct && itemProduct.isUpgrade
  }

  const renderOrderItem = (
    profile: ComputedCartParticipant,
    profileIndex: number,
    item: CartItem,
    itemIndex: number,
  ) => {
    const key = item.internalId
      ? item.internalId
      : `${profileIndex}-${itemIndex}`

    let removalFunction
    if (props.onRemove)
      removalFunction = () => props.onRemove && props.onRemove(item)

    return (
      <OrderItemV3
        key={key}
        restrictionWarning={item.restrictionWarning}
        originalPrice={item.originalPrice}
        totalPrice={getTotalPrice(item)}
        profileName={fullName(profile.firstName, profile.lastName)}
        productName={item.title || ''}
        pricingDetails={getPricingDetails(item)}
        isUpgrade={isUpgrade(item)}
        internalId={item.internalId}
        displayName={item.displayName}
        displayAgeRange={item.displayAgeRange}
        forceShowTotalLineItem={props.forceShowTotalLineItem}
        onAddonToggle={props.onAddonToggle}
        onRemove={removalFunction}
        applicableAddons={item.applicableAddons}
        appliedAddons={item.addons}
      />
    )
  }

  const renderOrderItems = (): ReactNode[] => {
    const { profiles } = props
    return profiles.reduce((acc, profile, idx1) => {
      return acc.concat(
        profile.items.map((item, idx2) => {
          return renderOrderItem(profile, idx1, item, idx2)
        }),
      )
    }, [])
  }

  return <PassList>{renderOrderItems()}</PassList>
}

export default OrderContentV3
